"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var IconButton_1 = __importDefault(require("@seaweb/coral/components/IconButton/IconButton"));
var Cancel_1 = __importDefault(require("@seaweb/coral/components/icons/Cancel"));
var ThemeProvider_1 = require("@seaweb/coral/components/ThemeProvider");
var useWrapEvent_1 = __importDefault(require("@seaweb/coral/hooks/useWrapEvent"));
var forwardAs_1 = __importDefault(require("@seaweb/coral/hoc/forwardAs"));
var DialogContext_1 = require("./DialogContext");
var WrappedIconButton = forwardAs_1.default(IconButton_1.default);
var StyledIconButton = styled_1.default(WrappedIconButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n\n  ", "\n"], ["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n\n  ",
    "\n"])), function (_a) {
    var spacing = _a.theme.spacing;
    return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    right: ", "px;\n  "], ["\n    right: ", "px;\n  "])), spacing.factor * 2);
});
var DialogClose = react_1.forwardRef(function DialogClose(_a, ref) {
    var as = _a.as, _b = _a.children, children = _b === void 0 ? react_1.default.createElement(Cancel_1.default, { "aria-label": "close", size: 20 }) : _b, _c = _a.colorType, colorType = _c === void 0 ? ThemeProvider_1.ColorTypes.Alternate : _c, onClick = _a.onClick, props = __rest(_a, ["as", "children", "colorType", "onClick"]);
    var setIsOpen = DialogContext_1.useDialogContext().setIsOpen;
    var handleClick = useWrapEvent_1.default(onClick, function () { return setIsOpen(false); });
    return (react_1.default.createElement(StyledIconButton, __assign({ _as: as, ref: ref, colorType: colorType, onClick: handleClick }, props), children));
});
exports.default = react_1.memo(DialogClose);
var templateObject_1, templateObject_2;
